import React from 'react';
import { useNavigate } from 'react-router-dom';
import PropertyRegistrationForm from '@/components/PropertyRegistrationForm';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

const PropertyRegistrationPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-orange-50 to-slate-100 py-12 px-4">
      {/* Back Button */}
      <div className="max-w-3xl mx-auto mb-6">
        <Button
          variant="ghost"
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-slate-600 hover:text-slate-900"
        >
          <ArrowLeft className="w-4 h-4" />
          Torna alla Home
        </Button>
      </div>

      {/* Registration Form */}
      <PropertyRegistrationForm />

      {/* Info Footer */}
      <div className="max-w-3xl mx-auto mt-8 text-center">
        <p className="text-sm text-slate-600">
          Hai già un account?{' '}
          <button
            onClick={() => navigate('/owner/login')}
            className="text-orange-600 font-semibold hover:text-orange-700 hover:underline"
          >
            Accedi ora
          </button>
        </p>
      </div>
    </div>
  );
};

export default PropertyRegistrationPage;
